const puppySell = {
    state: {
        pendingPuppySellCount: 0,
    },
    mutations: {
        setPendingPuppySellCount(state, pendingPuppySellCount) {
            state.pendingPuppySellCount = pendingPuppySellCount;
        },
    },
    getters: {
        getPendingPuppySellCount(state) {
            return state.pendingPuppySellCount;
        },
    },
};

export default puppySell;
